module.exports = __webpack_public_path__ + "img/Light Mode@4x-8.e850ea8c.png";